import { decodeFinderName, normalizeFinderSelection, toArray, toBoolean, toStringValue } from '@/features/charting-next/adapters/chartingAdapterUtils';

export function normalizeChartingFinderOptions(payload = []) {
    if (payload && typeof payload === 'object' && !Array.isArray(payload)) {
        return Object.entries(payload)
            .map(([value, label]) => ({
                value: toStringValue(value),
                label: decodeFinderName(label || value)
            }))
            .filter((item) => item.value && item.value !== '0');
    }

    return toArray(payload)
        .map((value) => ({
            value: toStringValue(value),
            label: decodeFinderName(value)
        }))
        .filter((item) => item.value && item.value !== '0');
}

export function normalizeChartingFinderFilters(payload = {}) {
    const finder = payload && typeof payload === 'object' ? payload : {};

    return {
        profitabilityBands: {
            M: toBoolean(finder?.tae_checkboxes?.M, false),
            A: toBoolean(finder?.tae_checkboxes?.A, false),
            B: toBoolean(finder?.tae_checkboxes?.B, false),
            C: toBoolean(finder?.tae_checkboxes?.C, false),
            D: toBoolean(finder?.tae_checkboxes?.D, false)
        },
        timing: {
            monthly: toBoolean(finder?.es_ipo?.[0], false),
            ipo: toBoolean(finder?.es_ipo?.[1], false)
        },
        directions: {
            bearish: toBoolean(finder?.direccio?.[0], false),
            bullish: toBoolean(finder?.direccio?.[1], false)
        },
        entryTypes: {
            per: toBoolean(finder?.entry_type?.per, false),
            rr: toBoolean(finder?.entry_type?.[0], false),
            rra: toBoolean(finder?.entry_type?.[1], false),
            lt: toBoolean(finder?.entry_type?.[2], false),
            lta: toBoolean(finder?.entry_type?.[3], false),
            se: toBoolean(finder?.entry_type?.[6], false)
        },
        valueTypes: {
            Stock: toBoolean(finder?.value_type?.Stock, false),
            ETF: toBoolean(finder?.value_type?.ETF, false)
        },
        amount: {
            min: toStringValue(finder?.min_amount),
            max: toStringValue(finder?.max_amount)
        },
        entryDistance: {
            min: toStringValue(finder?.min_entry_distance),
            max: toStringValue(finder?.max_entry_distance)
        },
        age: {
            min: toStringValue(finder?.min_edad),
            max: toStringValue(finder?.max_edad)
        },
        dividends: {
            zero: toBoolean(finder?.dividends?.[0], false),
            one: toBoolean(finder?.dividends?.[1], false),
            two: toBoolean(finder?.dividends?.[2], false),
            threePlus: toBoolean(finder?.dividends?.[3], false)
        },
        currencies: normalizeFinderSelection(finder?.currency),
        countries: normalizeFinderSelection(finder?.country),
        sectors: normalizeFinderSelection(finder?.sector),
        industries: normalizeFinderSelection(finder?.industry),
        raw: finder
    };
}

export function normalizeChartingFinderDefinition(payload = {}) {
    return {
        defaultFinder: payload?.defaultFinder || null,
        defaultFilters: normalizeChartingFinderFilters(payload?.defaultFinder || {}),
        preferences: payload?.preferences || [],
        availableCurrencies: payload?.availableCurrencies || [],
        availableCountries: payload?.availableCountries || [],
        availableSectors: payload?.availableSectors || [],
        availableIndustries: payload?.availableIndustries || [],
        raw: payload
    };
}
